'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useEffect, useRef, useState } from 'react';
import { Row } from 'reactstrap';

export default function InfiniteCarousel({ cards }: { cards: JSX.Element[] }) {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const requestRef = useRef<number | null>(null);
  const lastTimeRef = useRef<number | null>(null);
  const widthRef = useRef(0);
  const [position, setPosition] = useState(0);
  const [hover, setHover] = useState(false);
  const [inTransition, setIntransition] = useState(false);
  const speed = 0.07;

  const animate = (time: number) => {
    if (!lastTimeRef.current) lastTimeRef.current = time;
    if (hover) return;

    const deltaTime = time - lastTimeRef.current;
    lastTimeRef.current = time;

    if (inTransition) setIntransition(false);
    setPosition((prev) => {
      const newPos = prev + speed * deltaTime;
      if (newPos >= widthRef.current) {
        setIntransition(true);
        return newPos - widthRef.current;
      }
      return newPos;
    });

    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    const updateWidth = () => {
      if (elementRef.current) widthRef.current = elementRef.current.scrollWidth / 2;
    };
    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  useEffect(() => {
    if (hover) {
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
        requestRef.current = null;
      }
      return;
    }

    lastTimeRef.current = null;
    requestRef.current = requestAnimationFrame(animate);

    return () => {
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
        requestRef.current = null;
      }
    };
  }, [hover]);

  return (
    <Row
      className="overflow-hidden carousel-container position-relative"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className="position-absolute top-0 left-0 w-100 h-100 z-1"
        style={{
          background:
            'linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 1) 100%)',
        }}
      />
      <div
        ref={elementRef}
        className="d-flex gap-5"
        style={{
          transform: `translateX(-${position}px)`,
        }}
      >
        {cards.map((card, index) => (
          <div key={`first-${index}`}>{card}</div>
        ))}
        {cards.map((card, index) => (
          <div key={`second-${index}`}>{card}</div>
        ))}
      </div>
    </Row>
  );
}
